module.exports = __webpack_public_path__ + "a5aba340dc26185cbfd74bc9ee256d29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/images/b_bronze_large.svg
// module id = 979
// module chunks = 0